import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Layout from './components/shared/Layout';
import Spinner from './components/ui/Spinner';

// 懒加载页面
const LandingPage = lazy(() => import('./pages/LandingPage'));
const MakePage = lazy(() => import('./pages/MakePage'));
const ViewPage = lazy(() => import('./pages/ViewPage'));
const AnimatedViewPage = lazy(() => import('./pages/AnimatedViewPage'));
const SharePage = lazy(() => import('./pages/SharePage'));
const DemoPage = lazy(() => import('./pages/DemoPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Spinner size="lg" />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* 动画版观看页 — 独立于 Layout，全屏沉浸 */}
        <Route path="/card/:slug/animated" element={<AnimatedViewPage />} />

        <Route element={<Layout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/make" element={<MakePage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/card/:slug" element={<ViewPage />} />
          <Route path="/share/:slug" element={<SharePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
